module.exports = require("./../../_gen/starling/animation/Tween");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/animation/Tween.js
// module id = 131
// module chunks = 0